module.exports = __webpack_public_path__ + "img/img20.e771a5c6.jpg";